
import { includesValidator } from '../../common/utils/validator';

const MenuSize = {
  Medium: 'medium',
  Small: 'small',
};

const Alignment = {
  Top: 'top',
  Bottom: 'bottom',
  Left: 'left',
  Right: 'right',
  TopRight: 'top-right',
  TopLeft: 'top-left',
  BottomRight: 'bottom-right',
  BottomLeft: 'bottom-left',
};

export default {
  name: 'BbMenu',
  props: {
    attach: {
      default: undefined,
    },
    contentClass: {
      type: String,
      default: 'bb-menu',
    },
    displayItems: {
      type: [Number, String],
      default: 6,
    },
    size: {
      type: String,
      default: MenuSize.Medium,
      validator: includesValidator(MenuSize),
    },
    isCloseOnContentClick: {
      type: Boolean,
      default: true,
    },
    isCloseOnClick: {
      type: Boolean,
      default: true,
    },
    isOffsetY: {
      type: Boolean,
      default: false,
    },
    isOffsetX: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: Alignment.BottomRight,
      validator: includesValidator(Alignment),
    },
    nudgeBottom: {
      type: [Number, String],
      default: 0,
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0,
    },
    nudgeRight: {
      type: [Number, String],
      default: 0,
    },
    nudgeTop: {
      type: [Number, String],
      default: 0,
    },
    zIndex: {
      type: [Number, String],
      default: undefined,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    isAbsolute: {
      type: Boolean,
      default: false,
    },
    positionX: {
      type: Number,
      default: undefined,
    },
    positionY: {
      type: Number,
      default: undefined,
    },
    activator: {
      type: [String, Object],
      default: undefined,
    },
    maxHeight: {
      type: [Number, String],
      default: 'auto',
    },
    maxWidth: {
      type: [Number, String],
      default: 'auto',
    },
    minWidth: {
      type: [Number, String],
      default: undefined,
    },
    transition: {
      type: [Boolean, String],
      default: 'v-menu-transition',
    },
    value: {
      type: Boolean,
      default: false,
    },
    itemClass: {
      type: String,
      default: 'bb-menu-item',
    },
  },
  data() {
    return {
      contentMaxHeight: 0,
    };
  },
  computed: {
    showMenu: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedProps() {
      const mainSettings = {
        closeOnContentClick: this.isCloseOnContentClick,
        closeOnClick: this.isCloseOnClick,
        offsetY: this.isOffsetY,
        offsetX: this.isOffsetX,
        nudgeBottom: this.nudgeBottom,
        nudgeLeft: this.nudgeLeft,
        nudgeRight: this.nudgeRight,
        nudgeTop: this.nudgeTop,
        zIndex: this.zIndex,
        disabled: this.isDisabled,
        fixed: this.isFixed,
        absolute: this.isAbsolute,
        positionX: this.positionX,
        positionY: this.positionY,
        activator: this.activator,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        minWidth: this.minWidth,
        transition: this.transition,
        contentClass: this.contentClass,
      };
      return {
        ...mainSettings,
        ...this.alignment.split('-').reduce((props, prop) => ({ ...props, [prop]: true }), {
          top: false,
          left: false,
          right: false,
          bottom: false,
        }),
      };
    },
  },
  methods: {
    calculateMaxheight() {
      this.$refs.menuContent.$el.parentNode.style.display = 'inline-block';
      this.contentMaxHeight = [...this.$refs.menuContent.$el.querySelectorAll(`.${this.itemClass}`)].reduce(
        (totalWidth, el, index) => (index < this.displayItems ? totalWidth + el.offsetHeight : totalWidth),
        this.$refs.menuContent.$el.parentNode.offsetHeight,
      );
      this.$refs.menuContent.$el.parentNode.style.display = 'none';
    },
  },
};
